import './ActiveNoodle.css';
import Tip from './Tip.js';
import spiceFlame from '../assets/images/spiceFlame.png'
import React from "react";

function ActiveNoodle(props) {

    const tagList = [
        "stirfry",
        "tonkotsu",
        "cheese",
        "spicy",
        "vegan",
        "vegetarian",
        "seafood",
        "chicken",
        "beef",
        "miso",
        "soy",
        "vegetable",
        "jjajang",
        "udon",
    ];

  return (
      <div>
    <button className="xButton" onClick={() => props.setActiveNoodle(null)}>close</button>
    <div className="activeNoodlePopUp">
        <div className="activeNoodleDivElements">
        <p className="modalNoodleName">{props.noodle.name}</p>
        <img src={props.noodle.href} width="60%" alt={props.noodle.name}/>
        <p className="noodleModalDescription"> {props.noodle.description} </p>
        {props.noodle.tips.map((tip, index) => (
            <Tip tip={tip} />
        ))}
            <div style={{display: "flex", marginLeft: '5vw', marginTop: '1vw', marginBottom: '1vw'}}>
                <img src={props.noodle.country} className="countryFlag" alt="country flag" />
                {props.noodle.spice > 0 && 
                <div style={{display: 'flex'}}>
                    <img src={spiceFlame} className="spiceFlame" alt="red and black flame" />
                    <p className="noodleSpice"> { props.noodle.spice + "/10 spicy"}</p>
                </div>
                }
            </div>
        <div className="noodleTags">
                    {tagList.map((tag, index) => (
                        (props.noodle[tag.toString()]>0) ? 
                        (<div className="noodleTag" key={index}> 
                            <p className="noodleTagText"> {tag} </p>
                        </div>) : null
                    ))}
                    </div>
                    {/* <p className="noodleModalDescription"> REVIEWS: </p>
                    <p className="noodleModalDescription bottomText"> coming soon! </p> */}
        </div>

    </div>
    </div>
  );
}

export default ActiveNoodle;